import { css } from '@emotion/react';
import type * as React from 'react';
import { Button } from '@verclam/ui-kit';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';

const wrapperStyle = css`
	display: flex;
	justify-content: center;
`;

type Props = {
	readonly hasMore: boolean;
	readonly remainingCount: number;
	/** Size of a page: the button announces the next one, or what is left of it. */
	readonly rows: number;
	readonly isLoading: boolean;
	readonly onShowMore: () => void;
};

/** "Afficher N de plus": loads the next page; hidden once everything is loaded. */
const ShowMoreButton: React.FC<Props> = ({ hasMore, remainingCount, rows, isLoading, onShowMore }) => {
	return (
		<ConditionalLoader data={hasMore}>
			<div css={wrapperStyle}>
				<Button
					type="button"
					outlined
					severity="secondary"
					rounded
					label={`Afficher ${Math.min(rows, remainingCount)} de plus`}
					loading={isLoading}
					disabled={isLoading}
					onClick={onShowMore}
				/>
			</div>
		</ConditionalLoader>
	);
};

export default ShowMoreButton;
